import { ISurveyCreatorState } from './surveyCreatorState';
import { All as Actions } from './surveyCreatorActions';
import { SurveyCreatorConstants } from './surveyCreatorConstants';

const initialState: ISurveyCreatorState = {
  isLoading: false,
  schemaTypelist: [],
  selectedSchema: null,
  errorMessage: null,
  selectedType: null,
};

export function surveyCreator(
  state = initialState,
  action: Actions
): ISurveyCreatorState {
  switch (action.type) {
    case SurveyCreatorConstants.GET_SCHEMA_TYPES_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SurveyCreatorConstants.GET_SCHEMA_TYPES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        schemaTypelist: action.payload,
      };
    }
    case SurveyCreatorConstants.GET_SCHEMA_TYPES_FAILURE: {
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error,
      };
    }
    case SurveyCreatorConstants.GET_SCHEMA_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SurveyCreatorConstants.GET_SCHEMA_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        selectedSchema: action.payload,
      };
    }
    case SurveyCreatorConstants.GET_SCHEMA_FAILURE: {
      return {
        ...state,
        isLoading: false,
        selectedSchema: null,
        errorMessage: action.error,
      };
    }
    case SurveyCreatorConstants.SET_SELECTED_TYPE: {
      return {
        ...state,
        selectedType: action.payload,
      };
    }
    case SurveyCreatorConstants.SAVE_SURVEY_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SurveyCreatorConstants.SAVE_SURVEY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        selectedSchema: action.payload,
      };
    }
    case SurveyCreatorConstants.SAVE_SURVEY_FAILURE: {
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error,
      };
    }
    default:
      return state;
  }
}
